import Notification from '../../core/Notification';
import PropTypes from 'prop-types';
import React from 'react';
import DataDownload from '../DataDownload';
import withGS from '../withGShoc';
import { Typography } from '@material-ui/core';
import VersionWarning from '../VersionWarning';

class ProjectExport extends React.Component {

    render() {

        const { id, data, graph, exportName, projectType, cleanExportName } = this.props;

        if (data.isVersionOfProject) return <VersionWarning />;
        if (projectType && projectType !== data.type) return <Notification text="You are trying to view an incorrect project type." />;

        return (
            <div>
                {data.ontologyProjectAssociation &&
                    <Typography style={{ maxWidth: 800 }} data-test="associated-download-warning" variant="body2" paragraph>This project has associated ontology projects. By downloading the project you will also include the association information. Please note that to re-import this project you will first need to ensure any associated ontology projects are available.</Typography>
                }
                {data.largeDataSettings &&
                    <div style={{ maxWidth: 800 }}>
                        <Notification dataTest="large-data-export" text="The large data settting is applied to this project. Exports may take a long time to complete." />
                    </div>
                }
                <div style={{ display: 'flex' }}>
                    <div style={{ marginRight: 24 }}>
                        <DataDownload
                            title="Project"
                            graph={graph}
                            resource={id}
                            exportName={exportName}
                            message="Includes data for all components in a project information about the project itself. Use this option if you might want to reimport." />
                    </div>
                    {cleanExportName &&
                        <div>
                            <DataDownload
                                dataTest="clean-data-download"
                                title="Clean Project"
                                graph={graph}
                                resource={id}
                                exportName={cleanExportName}
                                message="Includes data for all components in a project with any system data removed. Use this option if you want a clean export." />
                        </div>
                    }
                </div>
            </div>
        );
    }
}

ProjectExport.propTypes = {
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    projectType: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    exportName: PropTypes.string.isRequired,
    cleanExportName: PropTypes.string
};

export default withGS(ProjectExport);